import { Grid } from 'seagull/components/Grid';
import { Typography } from 'seagull/components/Typography';
import { ClockIcon } from 'seagull/icons';
import ContactDetails from "../../../../components/AgreementStudio/ContactDetails/ContactDetails";
import { useContacts } from "../../../../hooks/reactQuery/queries/useContacts";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { getUICompanyName } from "../EditDraftsTable.utils";
import { useGetDraftContact } from "../hooks/useGetDraftContact";
import styles from "./Cells.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function EditContactModalContent(props) {
  const {
    draft,
    setDraft
  } = props;
  const {
    refresh
  } = useContacts();
  const contact = useGetDraftContact(draft);
  return /*#__PURE__*/_jsx(Grid, {
    align: "center",
    children: /*#__PURE__*/_jsx(ContactDetails, {
      existingContact: contact || undefined,
      showCustomerDetailsWarning: false,
      refreshExistingContacts: refresh,
      onChange: change => {
        switch (change.type) {
          case 'noContact':
            if (draft.clientContactId()) {
              setDraft(draft.setClientContactId(null));
            }
            break;
          case 'sampleContact':
            setDraft(draft.setSampleContact());
            break;
          case 'existingContact':
            setDraft(draft.setClientContactId(change.id));
            break;
        }
      }
    })
  });
}
export default function ContactCell(_ref) {
  let {
    draft,
    index,
    onOpenModal,
    getContact,
    isDisabled,
    disabledTooltip
  } = _ref;
  const contact = getContact(draft);
  const companyName = getUICompanyName(draft, contact);
  const scheduledDate = draft.scheduledDate();
  const onClick = () => onOpenModal({
    renderContent: _ref2 => {
      let {
        draft,
        setDraft
      } = _ref2;
      return {
        title: 'Primary contact',
        testid: "edit-contact-modal",
        onSubmit: defaultBehavior => {
          defaultBehavior();
        },
        content: /*#__PURE__*/_jsx(EditContactModalContent, {
          draft: draft,
          setDraft: setDraft
        })
      };
    }
  });
  return /*#__PURE__*/_jsxs(EditableTableCell, {
    testid: "edit-contact-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.scheduledTooltip,
      children: [companyName && /*#__PURE__*/_jsx(Typography, {
        ellipsis: true,
        weight: "normal",
        "data-testid": "company-name-".concat(index),
        children: companyName
      }), scheduledDate && /*#__PURE__*/_jsx("div", {
        "data-testid": "scheduled-tooltip-icon-".concat(index),
        children: /*#__PURE__*/_jsx(ClockIcon, {})
      })]
    }), contact && /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      variant: "paragraph2",
      skin: "secondary",
      "data-testid": "contact-name-".concat(index),
      children: "".concat(contact.firstName(), " ").concat(contact.lastName(), " (").concat(contact.email(), ")")
    }), !companyName && !contact && /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      skin: "secondary",
      children: "Not set"
    })]
  });
}